<template>
  <div id="app">
    <el-container>
      <el-header class="header-class">
        <div class="logo">
          <!-- <img src="./assets/img/toplogo.png" alt /> -->
          安徽星启仪实验设备有限公司
        </div>
        <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          :router="router">
          <el-menu-item index="/home">首页</el-menu-item>
          <el-menu-item index="/goin">关于我们</el-menu-item>
          <el-menu-item index="/product">产品中心</el-menu-item>
          <!-- <el-menu-item index="/news">新闻中心</el-menu-item> -->
          <el-menu-item index="/case">案例展示</el-menu-item>
          <!-- <el-menu-item index="/goin">联系我们</el-menu-item> -->
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>联系我们</p>
              <span>邮箱：17856527848@163.com</span>
              <span>电话：17856527848</span>
              <span>网址：www.xqylab.com</span>
              <span>地址：安徽省合肥市庐阳区阜南路东怡金融广场B座2604室</span>
            </li>
          </ul>
          <img src="./assets/img/ercode.png" alt />
        </div>
        <!-- <div class="copyright">
          <span>星启仪版权所有</span>
        </div> -->
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "home",
      isShow: false,
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = key != "/home";
      window.console.log(this.isShow);
    }
  },
  watch: {
    '$route'(to, from) {
      // to: 新路由对象
      // from: 旧路由对象
      this.defaultActive = to.path;
    }
  }
};
</script>

<style lang="scss">
.bottom_flex {
  display: flex;
  justify-content: space-between;
  align-content: center;
}

::v-deep.el-menu--horizontal>.el-menu-item {
  font-weight: 600;
}

.header-class {
  width: 100% !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    font-weight: 800;
    font-size: 21px;
    /* font-family: fangsong; */

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 216px;
  overflow: hidden;
  background-color: #14679f;

  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;

    .content-nav {
      display: flex;
      justify-content: space-around;

      .info {
        display: flex;
        flex-direction: column;
      }

      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;

        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }

        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }

    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }

  .copyright {
    height: 30px;
    background: #125688;

    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
